module.exports = __webpack_public_path__ + "static/ProfessionalsCarousel1-245285688cb578d0e6d7023cfc7f27ce.jpg";